import { ApplicationFormSectionStatusEnum } from "./SectionStaffInfo";

export interface ApplicationForm {
  orderNumber: string;
  typeOfProduct: string;
  destinationCouuntry: string;
  duration: string;
  yearOfDeparture: number;
  arrivalDate: Date|null;
  departurePeriod: string|null;
  uid: string;
  cultureCode: string;
  applicationFormTemplateGuid: string;
  nativeLanguage: string | null;
  label: string;
  applicationFormStatus: ApplicationFormSectionStatusEnum;
  submittedOn: Date | null;
  submittedByPartnerOn: Date | null;
  notifiedOfStaffValidationOn: Date | null;
  validationComment: string | null;
  avatarUrl: string | null;
  firstName: string;
  lastName: string;
  statusSynchronizedWithSupplierOn: Date|null;
  dataExportedToSupplierOn : Date|null;
  programType: ProgramTypeEnum;
  statusOfValidator: number;
  commentOfValidator: string | null;
  displayStatusOfValidatorDashboardSection: boolean;
  subLabel: string | null;
  cancelComment: string;
  hasUserPaxLgActive: boolean;
}

export interface ApplicationFormSectionStatus {
  uid: string,
  nbSectionApprouveds: number,
  nbSectionCompleteds: number,
  nbSectionIncompletes: number,
  nbAgreements: number,
  total: number
}

export interface ApplicationFormTemplate
{
  id: number,
  label: string,
  guid: string
}

export enum ProgramTypeEnum 
{
  Outbound = 0,
  Inbound = 1,
  Both = 2
}

export interface CreateAppFormResponseDTO
{
  applicationFormGuid: string
}

export enum DashboardSectionTypeEnum{
  ActiveWithStudent = 0,
  ActiveWithPartner = 1,
  ActiveWithWep = 2
}

export interface ApplicationFormDashboardTab {
  name: string;
  titleTab: string;
  description: string;
  listName: string;
  indexName: string;
}

export const TemplatePDFType: Record<string, number> =  {
    BioInfo : 0,
    StudentQuestionnaire : 1,
    StudentLetter : 2,
    ParentsLetter : 3,
    PhotoAlbumTemplate : 4,
    SchoolTranscriptTemplate : 5,
    TeacherTemplate : 6,
    LanguageTeacherTemplate : 7,
    MedicalInfoTemplate : 8,
    ImmunisationTemplate : 9,
    AllergyTemplate : 10,
    Agreement : 11
}

export const UploadedFileType: Record<string, number> = {
    PhotoAlbumUploaded : 0,
    SchoolTranscriptUploaded : 1,
    TeacherUploaded : 2,
    LanguageTeacherUploaded : 3,
    MedicalInfoUploaded : 4,
    ImmunisationUploaded : 5,
    AllergyUploaded : 6,
    VirtualFolder : 7
}

export const mapKeysToEnumValues = (keys: string[],  enumMap: Record<string, number>): number[] => {
    return keys
        .map(key => enumMap[key])
        .filter((value): value is number => value !== undefined);
};